import { Injectable } from '@angular/core';

import {Observable} from 'rxjs/Observable';

@Injectable()
export class ConsumerBusinessMainHandlerProvider {
	business: any = {
		Id: 0
	};

	constructor() {

	}
}


// WEBPACK FOOTER //
// ./src/providers/consumer-business-main-handler.ts